<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  components: {},
  props: {},
  data() {
    return {
      name1: "",
      name2: "",
      name3: "",
      name4: "",
      telegram: "",
      phone1: "",
      another_coordinator: "",
    };
  },
  validations: {
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
    telegram: { required, minLength: minLength(2), maxLength: maxLength(50) },
    phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
    another_coordinator: { required, minLength: minLength(4), maxLength: maxLength(500) },

    form: [
      "name1",
      "name2",
      "name3",
      "name4",
      "telegram",
      "phone1",
      "another_coordinator",
    ],
  },
  methods: {
    // validate
    validate() {
      // alert(this.$v);
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات المنسق</h5></div>

      <div class="col-md-12">
        <div class="row">
          <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
            <b-form-input
              id="name1"
              type="text"
              placeholder="ادخل الاسم"
              v-model="name1"
              :class="{ 'is-invalid': $v.name1.$error }"
            ></b-form-input>
            <div v-if="$v.name1.$error" class="invalid-feedback">
              <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name1.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name1.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
            <b-form-input
              id="name2"
              type="text"
              placeholder="ادخل اسم الاب"
              v-model="name2"
              :class="{ 'is-invalid': $v.name2.$error }"
            ></b-form-input>
            <div v-if="$v.name2.$error" class="invalid-feedback">
              <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name2.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name2.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
            <b-form-input
              id="name3"
              type="text"
              placeholder="ادخل اسم الجد"
              v-model="name3"
              :class="{ 'is-invalid': $v.name3.$error }"
            ></b-form-input>
            <div v-if="$v.name3.$error" class="invalid-feedback">
              <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name3.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name3.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
            <b-form-input
              id="name4"
              type="text"
              placeholder="ادخل اسم اب الجد"
              v-model="name4"
              :class="{ 'is-invalid': $v.name4.$error }"
            ></b-form-input>
            <div v-if="$v.name4.$error" class="invalid-feedback">
              <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
              <span v-if="!$v.name4.minLength"
                >يجب أن يتكون الاسم من حرفين على الأقل</span
              >
              <span v-if="!$v.name4.maxLength"
                >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            class="col-md-6 mb-3"
            label=" معرف التلجرام : "
            label-for="telegram"
          >
            <b-form-input
              id="telegram"
              type="text"
              placeholder="ادخل معرف التلجرام"
              v-model="telegram"
              :class="{ 'is-invalid': $v.telegram.$error }"
            ></b-form-input>
            <div v-if="$v.telegram.$error" class="invalid-feedback">
              <span v-if="!$v.telegram.required">هذا الحقل الزامي</span>
              <span v-if="!$v.telegram.minLength"
                >يجب أن يتكون معرف التلجرام من حرفين على الأقل</span
              >
              <span v-if="!$v.telegram.maxLength"
                >يجب أن يتكون معرف التلجرام من 50 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group class="col-md-6 mb-3" label=" رقم الهاتف : " label-for="phone1">
            <b-form-input
              id="phone1"
              type="number"
              placeholder="ادخل رقم الهاتف"
              v-model="phone1"
              :class="{ 'is-invalid': $v.phone1.$error }"
            ></b-form-input>
            <div v-if="$v.phone1.$error" class="invalid-feedback">
              <span v-if="!$v.phone1.required">هذا الحقل الزامي</span>
              <span v-if="!$v.phone1.minLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
              >
              <span v-if="!$v.phone1.maxLength"
                >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
              >
            </div>
          </b-form-group>
          <b-form-group
            class="col-md-12 mb-3"
            label="اذا كان هناك اكثر من منسق يرجى كتابة معلوماتهم جميعا هنا ."
            label-for="another_coordinator"
          >
            <b-form-textarea
              id="another_coordinator"
              type="text"
              placeholder="ادخل الاجابة"
              v-model="another_coordinator"
              :class="{ 'is-invalid': $v.another_coordinator.$error }"
              rows="3"
            ></b-form-textarea>
            <div v-if="$v.another_coordinator.$error" class="invalid-feedback">
              <span v-if="!$v.another_coordinator.required">هذا الحقل الزامي</span>
              <span v-if="!$v.another_coordinator.minLength"
                >يجب أن يتكون هذا الحقل من 4 حروف على الأقل</span
              >
              <span v-if="!$v.another_coordinator.maxLength"
                >يجب أن يتكون هذا الحقل من 500 حرف على الاكثر</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
